export default "__VITE_ASSET__845e0e3e__"